/**
 * @module app.shared
 */

import { autoinject } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { convertToString } from 'app/shared/lib/utilities';

@autoinject
export class ResolveUrlValueConverter {

    constructor(private readonly env: EnvironmentService) {}

    public toView(value: unknown): string | null {
        if(!value) { return null; }

        return this.env.resolveUrl(convertToString(value));
    }

}
